import { render, staticRenderFns } from "./mcJob.vue?vue&type=template&id=bf50ea36&scoped=true"
import script from "./mcJob.vue?vue&type=script&lang=js"
export * from "./mcJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf50ea36",
  null
  
)

export default component.exports